if (!customElements.get('cart-complete-recommendations')) {
  customElements.define(
    'cart-complete-recommendations',
    class CartCompleteRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.load();
      }

      async load() {
        const seeds = (this.dataset.seedIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
        const limit = Number(this.dataset.limit) || 3;
        const picked = [];
        const seen = new Set(seeds);

        const take = (products) => {
          products.forEach((product) => {
            if (picked.length >= limit || !product.available) return;
            const id = String(product.id);
            if (seen.has(id)) return;
            const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
            if (!variant) return;
            seen.add(id);
            picked.push({ product, variant });
          });
        };

        try {
          for (const seed of seeds.slice(0, 4)) {
            if (picked.length >= limit) break;
            take(await this.fetchProducts(seed, 'related'));
          }
        } catch (error) {
          console.error(error);
        }

        if (!this.isConnected) return;

        const list = this.querySelector('.cart-complete__list');
        const fallback = this.querySelector('template');
        if (!list) return;

        if (picked.length) {
          list.innerHTML = picked.map(({ product, variant }) => this.card(product, variant)).join('');
          this.hidden = false;
          return;
        }

        if (fallback && fallback.innerHTML.trim()) {
          list.innerHTML = fallback.innerHTML;
          this.hidden = false;
        }
      }

      fetchProducts(productId, intent) {
        const url = `${this.dataset.url}?product_id=${encodeURIComponent(productId)}&limit=10&intent=${intent}`;
        return fetch(url)
          .then((response) => response.json())
          .then((data) => data.products || []);
      }

      card(product, variant) {
        const title = this.escapeHtml(product.title);
        const url = this.escapeHtml(product.url || '#');
        const image = this.imageSrc(product);
        const price = this.escapeHtml(this.formatMoney(variant.price, this.dataset.moneyFormat));
        const label = this.escapeHtml(this.dataset.addLabel || 'Add to cart');
        const media = image
          ? `<img src="${this.escapeHtml(image)}" alt="${title}" loading="lazy" width="180" height="180">`
          : '';

        return `<article class="cart-complete__card">
          <a href="${url}" class="cart-complete__media" tabindex="-1">${media}</a>
          <a href="${url}" class="cart-complete__name">${title}</a>
          <p class="cart-complete__price">${price}</p>
          <product-form class="cart-complete__form" data-section-id="cart-complete"${this.dataset.cartPage === 'true' ? ' data-redirect-to-cart="true"' : ''}>
            <form class="form" novalidate="novalidate" data-type="add-to-cart-form">
              <input type="hidden" name="id" value="${this.escapeHtml(variant.id)}" class="product-variant-id">
              <button type="submit" name="add" class="cart-complete__add">
                <span>${label}</span>
                <div class="loading__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </form>
          </product-form>
        </article>`;
      }

      imageSrc(product) {
        const image = product.featured_image;
        let src = '';
        if (!image) return '';
        if (typeof image === 'string') src = image;
        else src = image.src || image.url || '';
        if (src.startsWith('//')) src = `https:${src}`;
        return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_180x$1$3');
      }

      formatMoney(cents, format) {
        const placeholder = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || '£{{amount}}';
        const match = formatString.match(placeholder);
        const token = match ? match[1] : 'amount';
        const formatWith = (number, precision, thousands, decimal) => {
          const fixed = (Number(number) / 100).toFixed(precision);
          const parts = fixed.split('.');
          const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
          return parts[1] ? `${whole}${decimal}${parts[1]}` : whole;
        };
        let value;
        switch (token) {
          case 'amount_no_decimals':
            value = formatWith(cents, 0, ',', '.');
            break;
          case 'amount_with_comma_separator':
            value = formatWith(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWith(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWith(cents, 2, "'", '.');
            break;
          default:
            value = formatWith(cents, 2, ',', '.');
        }
        return formatString.replace(placeholder, value);
      }

      escapeHtml(value) {
        return String(value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }
    }
  );
}
